import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

/**
 * Resolve a stored file/pictogram URL against the CURRENT environment's
 * backend (preview vs production have different domains). Historical data
 * (migrated photos, PPE pictograms) may contain an absolute URL baked with
 * whichever backend domain was active at the time it was created/uploaded -
 * that domain can be wrong/unreachable from a different environment (e.g. a
 * SOP viewed on production but the photo URL still points at the preview
 * domain, which can be asleep). This strips any domain and always rebuilds
 * the URL using the current REACT_APP_BACKEND_URL, so images always load
 * from whichever environment is actually serving the page.
 */
export function resolveFileUrl(url) {
  if (!url) return url;
  const match = url.match(/\/api\/(files|pictograms)\/.+$/);
  const path = match ? match[0] : url;
  return `${BACKEND_URL}${path.startsWith("/") ? path : `/${path}`}`;
}
